import * as React from "react";

import { Calendar } from "./Calendar/Calendar";

export const Planning = () => {
	return(
		<Calendar/>
	)
}